import React from "react";
import "./App.css";
import Routing from "./routes";
import useSEO from "./hooks/useSEO";
import SEOHead from "./components/SEOHead";

import "./assets/css/materialdesignicons.min.css";
import "./assets/css/pe-icon-7-stroke.min.css";
import "./assets/css/bootstrap.min.css";

const App = () => {
  const i18nextLng = window.localStorage.getItem("i18nextLng");
  const { seoData } = useSEO();
  
  i18nextLng === "ar"
    ? window.localStorage.setItem("dir", "rtl")
    : window.localStorage.setItem("dir", "ltr");
    
  return (
    <React.Fragment>
      {seoData && <SEOHead seoData={seoData} />}
      <Routing />
    </React.Fragment>
  );
};

export default App;
